import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { strings } from '../localization';
import { Dropdown } from 'react-bootstrap';

function Ariane(props){

    const navigate = useNavigate();

    const handleBackBtnClick = (e) => {
        e.preventDefault();
        sessionStorage.setItem('backClicked',true);
        props.back ? navigate(props.back) : navigate(-1);

    }

    const gotoPage = (page, event) => {
        navigate(page);
    }

    let hideDropdownMenu = false;

    return (
        <div className='ariane mb-4 d-flex justify-content-between bg-primary p-3'>
            <button onClick={ handleBackBtnClick } className='btn border-white border-1 text-white align-items-center d-flex'>
                <i className='fa fa-chevron-left me-3'></i> { strings.retour }
            </button>
            { props.children }            
            <div className='d-flex align-items-center'>
                { props.actions }
                { props.showSearch && 
                    <div className='input-group me-3 d-none'>
                        <span className='input-group-text'>
                            <i className='fa fa-search'></i>
                        </span>
                        <input type="text" className='form-control' placeholder={ strings.rechercher +'..'} />
                    </div>
                }
                {
                    hideDropdownMenu
                    ? <Link to="/" className='text-white'>
                        <i className='fa fa-home fs-2'></i>
                    </Link>
                    : <Dropdown onSelect={ gotoPage }>
                        <Dropdown.Toggle  id="dropdown-lang">
                            <i className='fa fa-home fs-2 text-white'></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className='dropdown-menu-lang'>
                            <Dropdown.Item eventKey="/dashboard">
                                { strings.home }
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="/client">
                                { strings.order_btn }
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="/customers">
                                { strings.clients }
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="/products">
                                { strings.articles }
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="/orders">
                                { strings.commandes }
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="/catalog">
                                { strings.catalogue }
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="/sync">
                                { strings.synchro }
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                }
            </div>
        </div>
    )
}

Ariane.defaultProps = {
    showSearch: false,
    back: null,
    actions: null
}

export default Ariane;